var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.975 141.056C492.636 118.679 460.62 125.802 444.938 133.062C443.857 133.562 443.51 134.902 444.164 135.898L469.961 175.204C470.93 176.682 473.633 176.408 474.645 174.959C481.105 165.716 500.208 151.58 511.564 143.938C512.534 143.286 512.74 141.941 511.975 141.056Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M442.939 134.031C457.738 126.497 491.773 117.68 511.975 141.056C512.74 141.941 512.534 143.286 511.564 143.938C498.296 152.867 474.45 170.662 472.555 179.158",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M391.492 352.146C397.394 334.565 386.082 328.217 379.689 327.24C356.083 344.821 361.984 365.819 367.886 374.121C380.869 389.357 411.656 399.027 425.426 401.957L429.852 384.376C426.311 372.656 406.738 365.819 397.394 363.866C389.132 361.522 390.017 355.076 391.492 352.146Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.99 327.877C172.669 327.641 174.296 327.359 176.337 328.336C178.586 329.412 183.424 333.052 187.586 345.175C189.885 351.874 197.18 355.44 203.878 353.14C210.577 350.84 214.143 343.546 211.843 336.847C206.268 320.607 197.816 310.182 187.409 305.202C177.108 300.272 166.889 301.674 160.118 305.118C159.799 305.28 159.487 305.456 159.183 305.644C140.734 317.064 129.357 317.956 123.42 316.809C117.636 315.692 115.26 312.354 114.63 310.829C114.478 310.462 114.31 310.102 114.125 309.751C102.692 288.028 82.3736 280.181 72.1889 278.963C65.1567 278.122 58.7742 283.141 57.9332 290.173C57.0922 297.206 62.1111 303.588 69.1433 304.429C72.7672 304.863 84.4624 308.862 91.2083 321.283C95.1224 330.148 104.219 339.221 118.555 341.991C132.94 344.77 150.723 340.89 171.99 327.877Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.243 253.619C255.07 228.965 304.574 215.954 326.097 212.529C322.184 194.43 328.739 150.308 386.265 118.61C406.81 113.229 453.182 114.501 474.314 162.635C477.249 170.951 481.358 192.278 474.314 211.062C473.336 213.997 471.966 221.628 474.314 228.672C480.184 240.901 481.358 267.414 439.094 275.632C433.224 312.025 442.519 375.91 447.899 403.303C447.899 424.435 435.181 421.892 428.822 417.978C415.908 408.586 410.723 357.322 409.745 332.864C405.049 316.428 392.135 322.102 386.265 326.994C368.655 341.082 370.122 361.235 373.057 369.551C383.623 394.205 386.265 410.152 386.265 415.043C381.569 436.175 366.698 426.783 359.85 419.446C351.632 414.75 340.772 386.444 336.37 372.879C316.412 364.975 303.596 369.585 299.683 372.879C327.117 382.996 336.589 399.901 342.06 408.738C349.999 429.285 330.011 427.272 320.227 422.381C305.636 410.139 295.28 404.771 287.943 403.303C265.637 399.781 250.277 392.053 245.385 388.629C237.167 393.325 219.459 390.585 211.633 388.629C162.325 369.845 184.239 318.189 201.36 294.709C207.23 274.751 222.394 259 229.243 253.619Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M323.747 212.53C302.224 215.954 255.07 228.966 229.243 253.62C222.394 259 207.23 274.751 201.36 294.709C184.239 318.189 162.325 369.845 211.633 388.629C219.459 390.586 237.167 393.325 245.385 388.629C250.277 392.053 265.637 399.782 287.943 403.304C295.28 404.771 302.618 409.174 320.227 422.381C330.011 427.273 349.577 429.719 342.24 409.174C334.902 394.499 322.627 381.34 299.683 372.879M245.385 297.644C292.345 326.994 291.367 349.985 285.008 357.812C282.66 364.855 285.986 368.573 287.943 369.551C292.041 370.371 295.958 371.506 299.683 372.879M299.683 372.879C303.596 369.586 316.412 364.975 336.37 372.879M336.37 372.879C336.859 356.117 336.076 321.124 329.032 315.254M336.37 372.879C340.772 386.445 351.045 410.012 359.85 419.446C366.698 426.784 384.797 435.589 386.265 415.044C386.265 410.152 383.623 394.205 373.057 369.551C370.122 361.236 368.655 341.082 386.265 326.994C392.135 322.103 405.049 316.428 409.744 332.864C410.723 357.322 415.908 408.587 428.822 417.979C435.181 421.892 447.899 424.436 447.899 403.304C442.518 375.911 433.224 312.026 439.094 275.632",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M462.028 138.5C442.951 122.847 400.941 101.88 365.721 128.881C343.22 147.959 305.554 196.094 334.904 236.01",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M384.798 262.425C404.281 270.705 447.531 290.141 471.08 258.43C471.277 258.165 471.455 257.872 471.602 257.576C475.742 249.22 478.159 241.927 471.972 220.413C471.597 219.109 471.653 217.721 472.154 216.46C478.061 201.579 486.61 177.679 471.38 158.905",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M415.718 221.334C418.164 221.334 423.642 220.747 425.99 218.399C425.012 220.356 422.175 224.269 418.653 224.269",
    stroke: "#1C1B1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M433.33 206.66C435.678 206.66 434.797 210.182 431.863 212.53C424.525 218.4 417.185 218.4 414.251 216.932C411.316 213.997 415.72 211.062 417.188 211.062C418.362 211.062 428.439 208.127 433.33 206.66Z",
    fill: "#1C1B1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M471.879 224.27C469.433 224.27 463.954 223.683 461.606 221.335C462.585 223.292 465.422 227.205 468.944 227.205",
    stroke: "#1C1B1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M458.633 209.595C456.285 209.595 457.166 213.117 460.1 215.465C467.438 221.335 474.778 221.335 477.712 219.867C480.647 216.932 476.243 213.997 474.775 213.997C473.601 213.997 463.524 211.062 458.633 209.595Z",
    fill: "#1C1B1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M413.264 204.192C421.579 202.235 438.505 195.094 439.679 182.18",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M478.5 202.5C470.184 200.543 458.463 195.094 457.289 182.18",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M339.01 103.144C367.114 93.9292 390.884 116.53 400.584 130.831C401.253 131.817 400.859 133.144 399.786 133.661L357.425 154.058C355.833 154.824 353.658 153.197 353.537 151.434C352.762 140.184 343.673 118.226 337.877 105.826C337.382 104.767 337.899 103.509 339.01 103.144Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M401.797 132.692C392.996 118.61 368.368 93.518 339.01 103.144C337.899 103.509 337.382 104.767 337.877 105.826C344.649 120.314 355.917 147.851 353.165 156.109",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M475.527 242.107C463.549 232.012 450.819 237.583 444.836 241.905C444.322 242.276 444.316 243.023 444.807 243.423C449.994 247.657 458.681 254.034 462.113 254.034C466.569 254.034 471.17 251.052 475.738 243.345C475.979 242.938 475.889 242.412 475.527 242.107Z",
    fill: "#1C1B1F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M463.631 250.684C463.631 250.684 467.56 253.62 466.329 259.712C465.097 265.804 455.822 271.229 455.822 271.229",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M409.513 231.464L378.337 212.53",
    stroke: "#1C1B1F",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M404.633 244.831L371.946 235.022",
    stroke: "#1C1B1F",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.133 438.884C185.026 437.213 220 428.538 220 418.087C220 406.441 176.572 397 123 397C69.4284 397 26 406.441 26 418.087C26 424.398 38.7533 430.061 58.9629 433.926C50.7362 435.973 45.6815 439.042 45.6815 443.235C45.6815 451.861 67.0809 458.855 93.4786 458.855C119.876 458.855 141.276 451.861 141.276 443.235C141.276 441.62 140.525 440.171 139.133 438.884Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/고질병_파보바이러스.d042fbf81a1646bb57020148db20fd9a.svg";
export { ForwardRef as ReactComponent };